import { Star, MessageSquare } from 'lucide-react';

const reviews = [
  {
    stars: 5,
    text: '"Boa música, bom atendimento, comida deliciosa, ambiente agradável."',
    author: 'Cliente',
    source: 'Avaliação no Google',
  },
  {
    stars: 5,
    text: '"Excelente preço das cervejas, gelada, comidinha muito boa."',
    author: 'Cliente',
    source: 'Avaliação no Google',
  },
];

export default function TestimonialsSection() {
  return (
    <section className="py-16 md:py-24 bg-cream-100">
      <div className="w-full px-4 sm:px-6 lg:px-10 xl:px-16">
        <div className="max-w-4xl mx-auto">
          {/* Header */}
          <div className="text-center mb-12 md:mb-16 reveal">
            <span className="inline-block text-gold-500 text-xs font-semibold tracking-widest uppercase mb-3">
              O QUE FALAM DE NÓS
            </span>
            <h2 className="font-heading text-3xl sm:text-4xl md:text-5xl font-bold text-brown-900 mb-4">
              O que aparece nas avaliações
            </h2>
          </div>

          {/* Rating */}
          <div className="text-center mb-10 reveal">
            <div className="inline-flex items-center gap-3 bg-white rounded-2xl px-8 py-6 shadow-sm">
              <span className="font-heading text-5xl md:text-6xl font-bold text-brown-900">4.4</span>
              <div className="text-left">
                <div className="flex items-center gap-0.5 mb-1">
                  {[1, 2, 3, 4].map((s) => (
                    <Star key={s} size={20} className="text-yellow-400" fill="#F5B041" />
                  ))}
                  <Star size={20} className="text-yellow-400" fill="url(#halfStar)" />
                </div>
                <p className="text-brown-600 text-sm">577 avaliações no Google</p>
              </div>
            </div>
          </div>

          {/* Reviews */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6">
            {reviews.map((review, i) => (
              <div
                key={i}
                className="bg-white rounded-2xl p-6 md:p-8 shadow-sm reveal"
                style={{ transitionDelay: `${i * 0.1}s` }}
              >
                <div className="flex items-center gap-0.5 mb-4">
                  {Array.from({ length: review.stars }).map((_, s) => (
                    <Star key={s} size={16} className="text-yellow-400" fill="#F5B041" />
                  ))}
                </div>
                <p className="text-brown-700 text-base leading-relaxed mb-4 italic">
                  {review.text}
                </p>
                <div className="flex items-center gap-3">
                  <div className="w-8 h-8 rounded-full bg-cream-200 flex items-center justify-center">
                    <MessageSquare size={14} className="text-brown-600" />
                  </div>
                  <div>
                    <p className="text-brown-900 text-sm font-semibold">{review.author}</p>
                    <p className="text-brown-500 text-xs">{review.source}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Link to more */}
          <div className="text-center mt-8 reveal">
            <a
              href="https://www.google.com/search?q=buteco+do+baiano+fortaleza+avaliações"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 text-gold-600 text-sm font-medium hover:text-gold-700 transition-colors"
            >
              Ver mais avaliações no Google
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M7 17L17 7M17 7H7M17 7V17"/></svg>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}